import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

export const SlideMenuPopover = styled("div")(({ theme }) => {
  const formatMedia = getFormatMedia(theme);

  return {
    backgroundColor: theme.palette.background.paper,
    border: 0,
    boxShadow: theme.shadows[16],
    display: "none",
    height: "100dvh",
    inset: 0,
    margin: 0,
    maxHeight: "none",
    maxWidth: "none",
    overscrollBehavior: "contain",
    overflow: "auto",
    padding: 0,
    width: "100%",

    "&:popover-open": {
      animation: "mobileMenuPopoverEnter 180ms ease-out",
      display: "block",
    },

    "&::backdrop": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },

    [formatMedia.BREAKPOINT_TABLET]: {
      inset: "0 auto 0 0",
      width: 400,
    },

    "@keyframes mobileMenuPopoverEnter": {
      from: {
        transform: "translateX(-100%)",
      },
      to: {
        transform: "translateX(0)",
      },
    },

    "@media (prefers-reduced-motion: reduce)": {
      "&:popover-open": {
        animation: "none",
      },
    },
  };
});
